export const getScopeLevelData = (scope: string, topic: string, videoUrl: string, weekNumber: number) => {
  if (scope === "course") {
    return topic
  } else if (scope === "unit") {
    return weekNumber
  } else {
    return videoUrl
  }
}

export const getScope = () => {
  if (typeof window === "undefined") {
    return "scope_na"
  }

  const courseId = localStorage.getItem("companion/external/swayam/courseId")
  const lessonId = localStorage.getItem("companion/external/swayam/lessonId")
  const unitId = localStorage.getItem("companion/external/swayam/unitId")

  if (lessonId && unitId && courseId) {
    return "lesson"
  } else if (unitId && courseId) {
    return "unit"
  } else {
    return "course"
  }
}
